import React from 'react';
import CandidateSearchCardSkeleton from '../../../components/candidate-search/CandidateSearchCardSkeleton';

/**
 * LoadingState component for displaying skeleton cards during initial load
 * 
 * @param {string} viewMode - The current view mode ('grid' or 'list')
 * @param {number} count - Number of skeleton cards to display (default: 6)
 */
const LoadingState = ({ viewMode = 'grid', count = 6 }) => {
  return (
    <div className="w-full">
      <div className={viewMode === 'grid' ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4' : 'flex flex-col gap-4'}>
        {Array(count).fill(0).map((_, index) => (
          <CandidateSearchCardSkeleton 
            key={`skeleton-${index}`} 
            viewMode={viewMode} 
            delay={index * 150} 
          />
        ))}
      </div>
    </div>
  );
};

export default LoadingState;